import React, { Fragment, useState, useMemo, useEffect } from 'react';

import { getBgClass, getIndentClass } from '../../utils/styleUtils';

import ExpenseRow from './ExpenseRow';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function ExpenseProjectRow(props) {
    const [showProject, setShowProject] = useState(false);

    // Handle expand all trigger from parent with staggered updates
    useEffect(() => {
        const t = props.expandAllTrigger;
        if (!t?.version) return;

        if (t.batch === 'rows' || t.batch === 'projects') {
            setShowProject(t.expanded);
        }
    }, [props.expandAllTrigger?.version]);

    // Calculate indentation levels
    const indentLevel = props.indentLevel;
    const childIndentLevel = indentLevel + 1;

    // Memoize common props to prevent unnecessary object creation
    const commonProps = useMemo(
        () => ({
            ExpenseMilestoneUpdateUrl: props.ExpenseMilestoneUpdateUrl,
            minDate: props.minDate,
            maxDate: props.maxDate,
            maxExpenseMilestonesCount: props.maxExpenseMilestonesCount,
            increaseMaxExpenseMilestonesCount: props.increaseMaxExpenseMilestonesCount,
            editingExpenseId: props.editingExpenseId,
            editingType: props.editingType,
            editingMilestoneId: props.editingMilestoneId,
            setExpenseEditing: props.setExpenseEditing,
            modalShow: props.modalShow,
            canEdit: props.canEdit,
            milestoneType: props.milestoneType,
            periods: props.periods,
            setLoading: props.setLoading,
            indentLevel: childIndentLevel,
            fetchCentralCashflow: props.fetchCentralCashflow,
            isProjectExpense: true,
            expandAllTrigger: props.expandAllTrigger,
            editAllTrigger: props.editAllTrigger,
        }),
        [props, childIndentLevel],
    );

    // Memoize expense rows
    const expenseRows = useMemo(() => {
        if (!props.project.expenses || props.project.expenses.length === 0) return null;

        return props.project.expenses.map((expense) => <ExpenseRow {...commonProps} key={`tr_expense_${expense.id}`} expense={expense} />);
    }, [props.project.expenses, commonProps]);

    return (
        <>
            <tr className={getBgClass(indentLevel, 'expense')}>
                <td className="tw-font-bold tw-cursor-pointer !tw-border-r-0" onClick={() => setShowProject(!showProject)}>
                    <div className={`tw-flex tw-items-center tw-gap-x-1.5 ${getIndentClass(indentLevel)}`}>
                        <div className="tw-font-medium tw-text-blue">{props.project.name}</div>
                        <div>{showProject ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                    </div>
                </td>
                <td className="tw-p-4 !tw-border-x-0"></td>
                <td className="tw-font-bold tw-cursor-pointer tw-border-r-2" onClick={() => setShowProject(!showProject)}></td>
                <td
                    colSpan={props.maxExpenseMilestonesCount * 2 + 3}
                    className="tw-font-bold tw-cursor-pointer !tw-border-l-0"
                    onClick={() => setShowProject(!showProject)}
                ></td>
            </tr>

            {showProject && <Fragment>{expenseRows}</Fragment>}
        </>
    );
}
